'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _filter = require('./filter');

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'pick',
    all: function all(keys) {
        return (0, _filter2.default)(function (value, key) {
            return keys.includes(key);
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/pick.js
// module id = 390
// module chunks = 35783957827783